module.exports = __webpack_public_path__ + "img/riviera-museum.4e19aac1.jpg";